import * as Sentry from '@sentry/react';
import { getDebugInfo, type DebugInfoExtras } from './getDebugInfo';

export const setSentryContext = (extras?: DebugInfoExtras): void => {
  const info = getDebugInfo(extras);

  Sentry.setUser({ email: info.outlook.email });
  Sentry.setContext('App', info.app);
  Sentry.setContext('Outlook', info.outlook);
  Sentry.setContext('Navigator', info.navigator);
  if (info.config) {
    Sentry.setContext('Config', info.config);
  }
};
